module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.$root.isOffline) ? _c('section', [_c('p', [_vm._v("These will be available in templates as the following variables:")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', _vm._l((_vm.renderedSettings), function(setting) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v("company." + _vm._s(setting.setting))]), _vm._v(" "), _c('td', [_c('form-group', {
      attrs: {
        "label": setting.label,
        "col-class": "col-md-3"
      }
    }, [(setting.type == 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (setting.value),
        expression: "setting.value"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          setting.value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.options), function(option) {
      return _c('option', [_vm._v(_vm._s(option))])
    })) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (setting.value),
        expression: "setting.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (setting.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          setting.value = $event.target.value
        }
      }
    })])], 1)])
  })), _vm._v(" "), _vm._m(0)])])]) : _c('page-offline-alert')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tfoot', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('button', {
    staticClass: "btn btn-success pull-right"
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-010b9a6b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CompanySettings.vue
// module id = 260
// module chunks = 0